import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().nonempty('Username is required'),
  password: z.string().nonempty('Password is required'),
});

// Forgot Password

export const phoneSchema = z.object({
  mobile: z
    .string()
    .min(1, 'Mobile number is required')
    .max(20, 'Mobile number must be at most 20 digits')
    .regex(/^\+[1-9]\d{1,14}$/, 'Please enter a valid phone number'),
});

export const resetPasswordSchema = z
  .object({
    otp: z.string().min(1, 'Verification code is required').min(6, 'OTP must be at least 6 digits'),
    newPassword: z
      .string()
      .min(1, 'Password is required')
      .min(8, 'Password must be at least 8 characters')
      .regex(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
        'Password must contain at least one uppercase letter, one lowercase letter, and one number'
      )
      // Same reason as the register form: the server's @IsStrongPassword() also
      // requires a symbol, so leaving it out here only moves the rejection to
      // after submit, where the message cannot say what is wrong.
      .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

// Add Account

export const accountSchema = z.object({
  accountType: z.string().min(1, 'Account type is required'),
  bankName: z
    .string()
    .trim()
    .min(3, 'Bank name must be at least 3 characters')
    .max(50, 'Bank name must be at most 50 characters'),

  holderName: z
    .string()
    .trim()
    .min(3, 'Holder name must be at least 3 characters')
    .max(50, 'Holder name must be at most 50 characters'),
  accountNumber: z
    .string()
    .trim()
    .min(9, 'Account number must be at least 9 digits')
    .regex(/^\d+$/, 'Only numbers allowed'),
  ifscCode: z.string().min(6, 'Must be at least 6 characters'),
});

export const upiSchema = z.object({
  name: z.string().trim().min(3, 'Name must be at least 3 characters'),
  upiId: z
    .string()
    .trim()
    .regex(/^[\w.-]+@[\w.-]+$/, 'Invalid UPI ID'),
  number: z
    .string()
    .trim()
    .max(20, 'Phone number (including +) must be at most 20 characters')
    .regex(/^\+?\d+$/, 'Phone number may start with + and must contain only digits'),
});

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, 'Current password is required'),

    newPassword: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .max(14, 'Password must be at most 14 characters')
      .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
      .regex(/[0-9]/, 'Password must contain at least one number')
      .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),

    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
  });